import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js'
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class UnitSelection extends BaseComponent {
	
	static get properties() {
		return {
			referenceTypes: {type: String},
			companyId: {type: String},
			selectionType: {type: String},
			groupId: {type: String},
			groupName: {type: String},
			/** When false, hides report-only bulk-group options and forces merge (runPerGroup=false). */
			showReportOptions: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		this.referenceTypes = 'TRACTOR,TRAILER,DRIVER';
		this.selectionType = 'FLEET';
		this.showReportOptions = true;
				
		var unitSelection = this;
		
		setTimeout(function(){
			unitSelection.init();
		});
	}
	
	render() {	
		return html`
			<style>
				.container {
					width: 100%;
					display: flex;
					flex-direction: row;					
				}
					
				.selection-text {
					flex: 1;
					margin-left: 10px;
					border: 1px dashed grey;
					padding: 5px;
					height: 30px;
				}
						
			</style>
			<div class="container">
				<vaadin-button itemid='select' @click='${this.clickSelect}'>
					<vaadin-icon icon="vaadin:truck"></vaadin-icon> Select Units				
				</vaadin-button>
				<span itemid='text' class="selection-text">
					Fleet
				</span>
			</div>
		`;
	}
	
	init() {
		var unitSelection = this;
			
		if (unitSelection.selectionType === 'FLEET') {	
			unitSelection.value = {
				type: 'FLEET',			
				customList: []
			};	
		} else if (unitSelection.selectionType === 'GROUP') {	
			unitSelection.value = {
				type: 'GROUP',
				groupId: unitSelection.groupId,
				groupTagExpression: '',
				customList: []
			};
			ElementUtil.query(unitSelection, 'text').innerHTML = 'GROUP: ' + unitSelection.groupName;
		} else if (unitSelection.selectionType === 'BULK_GROUP') {
			unitSelection.value = {
				type: 'BULK_GROUP',
				customList: [],
				bulkGroupConfig: {
					allGroups: false,
					runPerGroup: unitSelection.showReportOptions !== false,
					emailToGroupEmail: false,
					globalTagExpression: '',
					groups: []
				}
			};
			ElementUtil.query(unitSelection, 'text').innerHTML = 'Bulk Group: 0 groups';
		} else {
			unitSelection.value = {
				type: 'CUSTOM',			
				customList: []
			};
			ElementUtil.query(unitSelection, 'text').innerHTML = 'CUSTOM: 0 unit(s) selected';
		}
			
		var readyEvent = new CustomEvent('ready', { detail: '' });
		unitSelection.dispatchEvent(readyEvent);		
	}

	formatSelectionText(value) {
		if (!value) {
			return 'Fleet';
		}
		if (value.type === 'GROUP') {
			var groupLabel = value.groupId || '';
			var text = 'Group: ' + groupLabel;
			if (value.groupTagExpression) {
				text += ' (tags: ' + value.groupTagExpression + ')';
			}
			return text;
		}
		if (value.type === 'BULK_GROUP') {
			var config = value.bulkGroupConfig || {};
			if (config.allGroups) {
				return 'Bulk Group: All groups';
			}
			var count = (config.groups || []).length;
			return 'Bulk Group: ' + count + ' group' + (count === 1 ? '' : 's');
		}
		if (value.type === 'CUSTOM') {
			return 'CUSTOM: ' + (value.customList || []).length + ' unit(s) selected';
		}
		return 'Fleet';
	}
	
	clickSelect() {
		var unitSelection = this;

		var addUnitsWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Select Units',
			icon: 'vaadin:truck',				
			width: 450,
			height: 200,
			listeners: {
				ready: function() {						
					addUnitsWin.show();

					var allSelectedUnits = [];
					var allSelectedGroups = [];
					var TAG_HELP = 'Format: tag1|tag2&tag3 = tag1 or (tag2 and tag3)';

					var mainToolbar = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [
							{										
								tag: 'vaadin-combo-box',
								itemid: 'selectionType',
								'class': 'spacer-toolbar-item',
								'keep-open': true,
								style: 'width: 200px;',
								label: 'Selection Type',
								'item-value-path': 'code',
								'item-label-path': 'description',							
								value: unitSelection.value.type,
								postinit: function (combo) {															
									Service.getLookupService().getLookupValues('UnitSelectionType').then(function (data) {
										combo.items = data;
										combo.required = true;
									});
								},
								placeHolder: 'Select',
								listeners: {
									change: function() {
										
										var newValue = ElementUtil.query(mainToolbar, 'selectionType').value;										
										actionUpdateSelectionType(newValue);
										
									}
								}
							},							
							{										
								tag: 'vaadin-combo-box',
								itemid: 'unitGroup',
								'class': 'spacer-toolbar-item ',
								'keep-open': true,
								style: 'width: 200px;',
								label: 'Unit Group',
								'item-value-path': 'code',
								'item-label-path': 'description',
								postinit: function (combo) {															
									UnitService.getUnitLookupService().getUnitGroups(unitSelection.companyId).then(function(data) {
										combo.items = data;
									});
								},
								placeHolder: 'Select'
							},
							{
								tag: 'vaadin-text-field',
								itemid: 'groupTags',
								'class': 'spacer-toolbar-item hide',
								'keep-open': true,
								style: 'width: 220px;',
								label: 'Tags',
								placeholder: 'tag1|tag2&tag3',
								title: TAG_HELP
							},
							{
								tag: 'vaadin-checkbox',
								itemid: 'allGroups',
								'class': 'spacer-toolbar-item hide',
								'keep-open': true,
								label: 'All groups',
								listeners: {
									change: function() {
										actionUpdateBulkOptions();
									}
								}
							},
							{
								tag: 'vaadin-checkbox',
								itemid: 'runPerGroup',
								'class': 'spacer-toolbar-item hide',
								'keep-open': true,
								label: 'Run Report per Group',
								checked: true,
								listeners: {
									change: function() {
										actionUpdateBulkOptions();
									}
								}
							},
							{
								tag: 'vaadin-checkbox',
								itemid: 'emailToGroupEmail',
								'class': 'spacer-toolbar-item hide',
								'keep-open': true,
								label: 'Email report to Group Email',
								disabled: false
							},
							{
								tag: 'vaadin-text-field',
								itemid: 'globalTags',
								'class': 'spacer-toolbar-item hide',
								'keep-open': true,
								style: 'width: 240px;',
								label: 'Tags to apply to all groups',
								placeholder: 'tag1|tag2&tag3',
								title: TAG_HELP
							},
							{
								tag: 'span',
								itemid: 'tagHelp',
								'class': 'spacer-toolbar-item hide',
								style: 'font-size: 11px; color: #666; max-width: 280px;',
								innerHTML: TAG_HELP
							}
						]
					});
					
					var mainFooter = ElementUtil.create({
						tag: 'div',
						slot: 'footer',
						style: 'text-align: center;',
						defaults: {
							tag: 'vaadin-button'
						},
						children: [
							{
								tag: 'hr'
							},
							{
								theme: 'primary',
								children: [
									ElementUtil.makeIcon('vaadin:check', ' Select')
								],
								listeners: {
									click: function () {

										//save off unit selection
										
										//validation 
										var valid = true;
										var selectionType = ElementUtil.query(mainToolbar, 'selectionType').value;
										if (selectionType === 'GROUP') {
											if (!ElementUtil.query(mainToolbar, 'unitGroup').value) {
												valid = false;
												DL.MessageUtil.showToastError('Missing Group');
											}
										} else if (selectionType === 'CUSTOM') {
											if (allSelectedUnits.length <= 0) {
												valid = false;
												DL.MessageUtil.showToastError('Add units to selection');
											}
										} else if (selectionType === 'BULK_GROUP') {
											var allGroupsChecked = ElementUtil.query(mainToolbar, 'allGroups').checked;
											if (!allGroupsChecked && allSelectedGroups.length <= 0) {
												valid = false;
												DL.MessageUtil.showToastError('Add groups to selection or choose All groups');
											}
										}

										if (valid) {
											unitSelection.value = {
												type: ElementUtil.query(mainToolbar, 'selectionType').value,
												customList: []
											};

											if (unitSelection.value.type === 'GROUP') {
												unitSelection.value.groupId = ElementUtil.query(mainToolbar, 'unitGroup').value;
												unitSelection.value.groupTagExpression = ElementUtil.query(mainToolbar, 'groupTags').value || '';
											
												var groupChanageEvent = new CustomEvent('group-change', { 
													detail: {
														unitGroupId: unitSelection.value.groupId
													}
												});
												unitSelection.dispatchEvent(groupChanageEvent);												
											}

											if (unitSelection.value.type === 'CUSTOM') {
												allSelectedUnits.forEach(function (item) {
													unitSelection.value.customList.push({
														unitId: item.unitId,
														unitRefNo: item.unitRefNo,
														referenceType: item.referenceType
													});
												});
											}

											if (unitSelection.value.type === 'BULK_GROUP') {
												var reportOptions = unitSelection.showReportOptions !== false;
												unitSelection.value.bulkGroupConfig = {
													allGroups: !!ElementUtil.query(mainToolbar, 'allGroups').checked,
													runPerGroup: reportOptions
															? !!ElementUtil.query(mainToolbar, 'runPerGroup').checked
															: false,
													emailToGroupEmail: reportOptions
															? !!ElementUtil.query(mainToolbar, 'emailToGroupEmail').checked
															: false,
													globalTagExpression: ElementUtil.query(mainToolbar, 'globalTags').value || '',
													groups: allSelectedGroups.map(function(group) {
														return {
															unitGroupId: group.unitGroupId,
															groupName: group.groupName,
															groupCode: group.groupCode,
															tagExpression: group.tagExpression || ''
														};
													})
												};
											}

											var selectedText = ElementUtil.query(mainToolbar, 'selectionType').selectedItem.description;
											if (unitSelection.value.type === 'GROUP') {
												selectedText += ': ' + ElementUtil.query(mainToolbar, 'unitGroup').selectedItem.description;
												if (unitSelection.value.groupTagExpression) {
													selectedText += ' (tags)';
												}
											} else if (unitSelection.value.type === 'CUSTOM') {
												selectedText += ': ' + unitSelection.value.customList.length + ' unit(s) selected';
											} else if (unitSelection.value.type === 'BULK_GROUP') {
												selectedText = unitSelection.formatSelectionText(unitSelection.value);
											}
											ElementUtil.query(unitSelection, 'text').innerHTML = selectedText;
											
											addUnitsWin.close();
										}
										
										
									}
								}
							},
							{
								theme: 'tertiary',
								innerHTML: 'Cancel',
								style: 'margin-left: 10px;',
								listeners: {
									click: function () {										
										addUnitsWin.close();
									}
								}
							}
						]
					});					

					var selectFilterToolbar = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [
							{
								tag: 'vaadin-combo-box',
								itemid: 'referenceType',
								name: 'referenceType',
								label: 'Reference Type',
								'item-value-path': 'code',
								'item-label-path': 'description',								
								required: true,
								postinit: function (combo) {
									Service.getLookupService().getLookupValues('ReferenceType').then(function (data) {

										//get request unit types
										var pullAllSet = {											
										};
										if (unitSelection.referenceTypes) {
											var types = unitSelection.referenceTypes.split(',');
											types.forEach(function(type){
												pullAllSet[type] = type;
											});											
										} else {
											pullAllSet = null;
										}

										var unitRefs = [];
										data.forEach(function (reference) {
											if (reference.unitReference) {
												if (pullAllSet) {
													if (pullAllSet[reference.code]) {
														unitRefs.push(reference);
													}
												} else {												
													unitRefs.push(reference);
												}
											}
										});

										combo.items = unitRefs;
										
										if (unitRefs.length > 0) {
											var containsTractor = false;
											unitRefs.forEach(function(item){
												if (item.code === 'TRACTOR') {
													containsTractor = true;
												}
											});
											if (containsTractor) {
												combo.value = 'TRACTOR';												
											} else {
												combo.value = unitRefs[0].code;	
											}
										} else if (!pullAllSet) {
											combo.value = 'TRACTOR';
										}
									});
								},
								placeHolder: 'Select',
								listeners: {
									change: function() {
										actionSelectGrid();
									}
								}
							},
							{										
								tag: 'vaadin-combo-box',
								itemid: 'filterType',
								'class': 'spacer-toolbar-item',
								'keep-open': true,
								style: 'width: 200px;',
								label: 'Filter By',
								'item-value-path': 'code',
								'item-label-path': 'description',
								required: true,
								value: 'unitRefNo',
								postinit: function (combo) {						
									var lookups = [											
										{
											code: 'unitRefNo',
											description: 'Reference No'
										},
										{
											code: 'tags',
											description: 'Tag'
										}
									];
									combo.items = lookups;
								},
								placeHolder: 'Select'
							},
							{
								tag: 'vaadin-text-field',
								itemid: 'filterValue',
								'class': 'spacer-toolbar-item',
								'keep-open': true,
								label: 'Value',
								listeners: {
									input: {
										fn: function() {
											actionSelectGrid();
										},
										buffer: 2000
									}
								}
							}								
						]
					});	

					var selectToolbarContainer = ElementUtil.create({
						tag: 'div',
						slot: 'toolbar',
						children: [
							{
								tag: 'dl-section-title',
								title: 'Available',									
								style: 'margin-top: 20px;'
							},
							selectFilterToolbar
						]
					});						

					var selectGrid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'wrap-cell-content row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						'rows-draggable': true,
						'drop-mode': 'on-grid',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true,
							listeners: {
								'direction-changed': function (event) {
									if (event.detail && event.detail.value) {
										selectGrid.currentSortField = event.target.path;
										selectGrid.currentSortDirection = event.detail.value.toUpperCase();
										selectPagingToolbar.loadCurrentPage();
									}
								}
							}
						},
						children: [	
							{
								tag: 'vaadin-grid-selection-column',
								itemid: 'selectionColumn',
								'auto-select': true,
								'auto-width': true,
								listeners: {
									'select-all-changed': function () {

									}
								}
							},
							{
								path: 'description',
								header: 'Unit Ref No',
								width: '9em'
							}
						],
						listeners: {
							'active-item-changed': function (event) {
								const item = event.detail.value;
								//selectGrid.selectedItems = item ? [item] : [];

							},
							'grid-dragstart': function(event) {
								selectGrid.draggedItems = event.detail.draggedItems;
							},
							'grid-dragend': function(event) {
								delete selectGrid.draggedItems;
							},
							'grid-drop': function(event) {
								const draggedUnits = inGrid.draggedItems;
								if (!draggedUnits) {
									return;
								}

								var unitIds = {
								};
								draggedUnits.forEach(function (item) {
									unitIds[item.unitId] = true;
								});

								var keep = [];
								allSelectedUnits.forEach(function (item) {
									if (!unitIds[item.unitId]) {
										keep.push(item);
									}
								});
								allSelectedUnits = keep;
								actionSelectGrid();
								actionUpdatedSelection(allSelectedUnits.slice(0));
								
							}
						}
					});

					var selectPagingToolbar = ElementUtil.create({
						tag: 'dl-paging-toolbar',
						slot: 'footer',
						pageSize: 250,
						postinit: function(element) {
							element.grid = selectGrid;
							element.loader = function(backingGrid, pageNumber, pagingToolbar) {
								var pageRange = pagingToolbar.pullRange();
								var loadMask = selectGrid.showLoading();

								var loadData = function() {

									selectGrid.currentFilter = {
										offset: pageRange.offset,
										max: pageRange.max,
										sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'unitRefNo',
										sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',																	
										filterField: ElementUtil.query(selectFilterToolbar, 'filterType').value,
										filterValue: ElementUtil.query(selectFilterToolbar, 'filterValue').value
									};

									var referenceType = ElementUtil.query(selectFilterToolbar, 'referenceType').value;																		
									if (!referenceType) {
										if (unitSelection.referenceTypes) {
											var types = unitSelection.referenceTypes.split(',');
											if (types.length > 0) {
												referenceType = types[0];
											} 
										} else {
											referenceType = 'TRACTOR';
										}
									}

									var successHandler = function(records) {
										loadMask.remove();
										selectGrid.activeItem = null;						
										
										var filtered = [];
										var inMap = {											
										};
										allSelectedUnits.forEach(function(item) {
											inMap[item.referenceType + '-' + item.unitRefNo] = true;	
										});
										records.data.forEach(function(item) {
											if (!inMap[referenceType + '-' + item.description]) {
												filtered.push(item);
											}
										});
																				
										selectGrid.items = filtered;										

										selectPagingToolbar.totalRecords = records.totalNumber;
										selectPagingToolbar.updatePager();						
									};

									if (referenceType) {
										UnitService.getUnitLookupService().getUnitsForCompany(unitSelection.companyId, referenceType, selectGrid.currentFilter).then(function(records){
											successHandler(records);
										});						
									}
								};	

								loadData();

							};
						},
						listeners: {
							ready: function() {					
								selectPagingToolbar.loadCurrentPage();					
							}
						}

					});

					var inFilterToolbar = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [								
							{
								tag: 'vaadin-text-field',
								itemid: 'filterUnitRefNo',
								'class': 'spacer-toolbar-item',
								'keep-open': true,
								label: 'Unit Ref No',
								listeners: {
									input: {
										fn: function() {
											
											var filterValue = ElementUtil.query(inFilterToolbar, 'filterUnitRefNo').value;
											
											var filtered = [];											
											allSelectedUnits.forEach(function(item){
												if (item.unitRefNo.toLowerCase().includes(filterValue.toLowerCase())) {
													filtered.push(item);
												}
											});
											
											actionUpdatedSelection(filtered);
										},
										buffer: 200
									}
								}
							}								
						]
					});	

					var inGrid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'wrap-cell-content row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						'rows-draggable': true,
						'drop-mode': 'on-grid',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true,
							listeners: {
								'direction-changed': function (event) {
									if (event.detail && event.detail.value) {
										inGrid.currentSortField = event.target.path;
										inGrid.currentSortDirection = event.detail.value.toUpperCase();
									}
								}
							}
						},
						children: [
							{
								tag: 'vaadin-grid-selection-column',
								itemid: 'selectionColumn',
								'auto-select': true,
								'auto-width': true,
								listeners: {
									'select-all-changed': function () {										
									}
								}
							},
							{
								path: 'referenceType',
								header: 'Reference Type',
								width: '7em'
							},
							{
								path: 'unitRefNo',
								header: 'Unit Ref No',
								width: '9em'
							}
						],
						listeners: {
							'active-item-changed': function (event) {
								const item = event.detail.value;
								inGrid.selectedItems = item ? [item] : [];																			
							},
							'grid-dragstart': function(event) {
								inGrid.draggedItems = event.detail.draggedItems;
							},
							'grid-dragend': function(event) {
								delete this.draggedItems;
							},
							'grid-drop': function (event) {
								const draggedUnits = selectGrid.draggedItems;
								if (!draggedUnits) {
									return;
								}
								
								draggedUnits.forEach(function (item) {
									allSelectedUnits.push({
										referenceType: ElementUtil.query(selectFilterToolbar, 'referenceType').value,
										unitRefNo: item.description,
										unitId: item.code
									});
								});

								actionUpdatedSelection(allSelectedUnits.slice(0));
								actionSelectGrid();
							}
						}
					});	
					
					var inToolbarContainer = ElementUtil.create({
							tag: 'div',
							slot: 'toolbar',
							children: [
								{
									tag: 'dl-section-title',
									title: 'Selected',									
									style: 'margin-top: 20px;'
								},
								inFilterToolbar
							]
					});	
				
					var splitLayout = ElementUtil.create({
						tag: 'vaadin-split-layout',				
						slot: 'primary',
						style: 'height: 100%;',
						children: [
							{
								tag: 'dl-flex-layout',
								children: [
									selectToolbarContainer,
									selectGrid,
									selectPagingToolbar
								]
							},
							{
								tag: 'dl-flex-layout',
								children: [
									inToolbarContainer,
									inGrid
								]
							}
						]
					});						
					
					var splitWrapper = ElementUtil.create({
						tag: 'div',
						itemId: 'splitWrapper',
						slot: 'primary',
						style: 'height: 100%;',
						children: [
							splitLayout
						]
					});

					// ---- Bulk Group dual grids ----
					var bulkFilterToolbar = ElementUtil.create({
						tag: 'dl-toolbar',
						theme: 'spacing',
						children: [
							{
								tag: 'vaadin-combo-box',
								itemid: 'bulkFilterType',
								'class': 'spacer-toolbar-item',
								'keep-open': true,
								style: 'width: 160px;',
								label: 'Filter By',
								'item-value-path': 'code',
								'item-label-path': 'description',
								value: 'groupName',
								postinit: function (combo) {
									combo.items = [
										{code: 'groupName', description: 'Group Name'},
										{code: 'groupCode', description: 'Code'}
									];
								}
							},
							{
								tag: 'vaadin-text-field',
								itemid: 'bulkFilterValue',
								'class': 'spacer-toolbar-item',
								'keep-open': true,
								label: 'Value',
								listeners: {
									input: {
										fn: function() {
											actionBulkSelectGrid();
										},
										buffer: 500
									}
								}
							}
						]
					});

					var bulkAvailableTitle = ElementUtil.create({
						tag: 'div',
						slot: 'toolbar',
						children: [
							{
								tag: 'dl-section-title',
								title: 'Available Groups',
								style: 'margin-top: 20px;'
							},
							bulkFilterToolbar
						]
					});

					var bulkAvailableGrid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'wrap-cell-content row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						'rows-draggable': true,
						'drop-mode': 'on-grid',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true
						},
						children: [
							{
								tag: 'vaadin-grid-selection-column',
								'auto-select': true,
								'auto-width': true
							},
							{
								path: 'groupName',
								header: 'Group Name',
								width: '10em'
							},
							{
								path: 'groupCode',
								header: 'Code',
								width: '7em'
							}
						],
						listeners: {
							'grid-dragstart': function(event) {
								bulkAvailableGrid.draggedItems = event.detail.draggedItems;
							},
							'grid-dragend': function() {
								delete bulkAvailableGrid.draggedItems;
							},
							'grid-drop': function() {
								const dragged = bulkSelectedGrid.draggedItems;
								if (!dragged) {
									return;
								}
								var removeIds = {};
								dragged.forEach(function(item) {
									removeIds[item.unitGroupId] = true;
								});
								allSelectedGroups = allSelectedGroups.filter(function(item) {
									return !removeIds[item.unitGroupId];
								});
								actionBulkUpdatedSelection();
								actionBulkSelectGrid();
							}
						}
					});

					var bulkPagingToolbar = ElementUtil.create({
						tag: 'dl-paging-toolbar',
						slot: 'footer',
						pageSize: 100,
						postinit: function(element) {
							element.grid = bulkAvailableGrid;
							element.loader = function(backingGrid, pageNumber, pagingToolbar) {
								var pageRange = pagingToolbar.pullRange();
								var loadMask = bulkAvailableGrid.showLoading();
								var filter = {
									offset: pageRange.offset,
									max: pageRange.max,
									sortField: 'groupName',
									sortOrder: 'ASC',
									status: 'A',
									filterField: ElementUtil.query(bulkFilterToolbar, 'bulkFilterType').value || 'groupName',
									filterValue: ElementUtil.query(bulkFilterToolbar, 'bulkFilterValue').value || ''
								};
								UnitService.getUnitGroupService().getUnitGroups(filter).then(function(records) {
									loadMask.remove();
									var selectedIds = {};
									allSelectedGroups.forEach(function(item) {
										selectedIds[item.unitGroupId] = true;
									});
									var filtered = [];
									(records.data || []).forEach(function(item) {
										if (!selectedIds[item.unitGroupId]) {
											filtered.push(item);
										}
									});
									bulkAvailableGrid.items = filtered;
									bulkPagingToolbar.totalRecords = records.totalNumber;
									bulkPagingToolbar.updatePager();
								}, function() {
									loadMask.remove();
								});
							};
						},
						listeners: {
							ready: function() {
								bulkPagingToolbar.loadCurrentPage();
							}
						}
					});

					var bulkSelectedToolbar = ElementUtil.create({
						tag: 'dl-toolbar',
						theme: 'spacing',
						children: [
							{
								tag: 'vaadin-text-field',
								itemid: 'selectedGroupTags',
								'class': 'spacer-toolbar-item',
								'keep-open': true,
								style: 'width: 220px;',
								label: 'Selected Group Tags',
								placeholder: 'tag1|tag2&tag3',
								title: TAG_HELP
							},
							{
								tag: 'vaadin-button',
								theme: 'tertiary',
								innerHTML: 'Apply Tags',
								listeners: {
									click: function() {
										var selected = bulkSelectedGrid.selectedItems || [];
										if (selected.length === 0) {
											DL.MessageUtil.showToastError('Select a group in Groups in Report');
											return;
										}
										var tagValue = ElementUtil.query(bulkSelectedToolbar, 'selectedGroupTags').value || '';
										selected.forEach(function(selectedItem) {
											allSelectedGroups.forEach(function(group) {
												if (group.unitGroupId === selectedItem.unitGroupId) {
													group.tagExpression = tagValue;
												}
											});
										});
										actionBulkUpdatedSelection();
									}
								}
							},
							{
								tag: 'vaadin-button',
								theme: 'tertiary error',
								innerHTML: 'Clear Tags',
								listeners: {
									click: function() {
										var selected = bulkSelectedGrid.selectedItems || [];
										selected.forEach(function(selectedItem) {
											allSelectedGroups.forEach(function(group) {
												if (group.unitGroupId === selectedItem.unitGroupId) {
													group.tagExpression = '';
												}
											});
										});
										ElementUtil.query(bulkSelectedToolbar, 'selectedGroupTags').value = '';
										actionBulkUpdatedSelection();
									}
								}
							}
						]
					});

					var bulkSelectedTitle = ElementUtil.create({
						tag: 'div',
						slot: 'toolbar',
						children: [
							{
								tag: 'dl-section-title',
								title: 'Groups in Report',
								style: 'margin-top: 20px;'
							},
							bulkSelectedToolbar
						]
					});

					var bulkSelectedGrid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'wrap-cell-content row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						'rows-draggable': true,
						'drop-mode': 'on-grid',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true
						},
						children: [
							{
								tag: 'vaadin-grid-selection-column',
								'auto-select': true,
								'auto-width': true
							},
							{
								path: 'groupName',
								header: 'Group Name',
								width: '10em'
							},
							{
								path: 'groupCode',
								header: 'Code',
								width: '7em'
							},
							{
								path: 'tagExpression',
								header: 'Tags',
								width: '10em'
							}
						],
						listeners: {
							'active-item-changed': function(event) {
								const item = event.detail.value;
								bulkSelectedGrid.selectedItems = item ? [item] : [];
								ElementUtil.query(bulkSelectedToolbar, 'selectedGroupTags').value =
									item && item.tagExpression ? item.tagExpression : '';
							},
							'grid-dragstart': function(event) {
								bulkSelectedGrid.draggedItems = event.detail.draggedItems;
							},
							'grid-dragend': function() {
								delete bulkSelectedGrid.draggedItems;
							},
							'grid-drop': function() {
								const dragged = bulkAvailableGrid.draggedItems;
								if (!dragged) {
									return;
								}
								dragged.forEach(function(item) {
									allSelectedGroups.push({
										unitGroupId: item.unitGroupId,
										groupName: item.groupName,
										groupCode: item.groupCode,
										tagExpression: ''
									});
								});
								actionBulkUpdatedSelection();
								actionBulkSelectGrid();
							}
						}
					});

					var bulkSplitLayout = ElementUtil.create({
						tag: 'vaadin-split-layout',
						style: 'height: 100%;',
						children: [
							{
								tag: 'dl-flex-layout',
								style: 'height: 100%;',
								children: [
									bulkAvailableTitle,
									bulkAvailableGrid,
									bulkPagingToolbar
								]
							},
							{
								tag: 'dl-flex-layout',
								style: 'height: 100%;',
								children: [
									bulkSelectedTitle,
									bulkSelectedGrid
								]
							}
						]
					});

					var bulkSplitWrapper = ElementUtil.create({
						tag: 'div',
						itemId: 'bulkSplitWrapper',
						slot: 'primary',
						style: 'height: 100%;',
						'class': 'hide',
						children: [
							bulkSplitLayout
						]
					});

					var unitFlexLayout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [
							mainToolbar,
							splitWrapper,
							bulkSplitWrapper,
							mainFooter
						]
					});
					addUnitsWin.addToContentElement(unitFlexLayout);

					var actionSelectGrid = function() {
						selectPagingToolbar.loadPage(1);	
					};

					var actionUpdatedSelection = function(selectedUnits) {						
						inGrid.items = selectedUnits;
					};

					var actionBulkSelectGrid = function() {
						bulkPagingToolbar.loadPage(1);
					};

					var actionBulkUpdatedSelection = function() {
						bulkSelectedGrid.items = allSelectedGroups.slice(0);
					};

					var actionUpdateBulkOptions = function() {
						var runPerGroup = ElementUtil.query(mainToolbar, 'runPerGroup').checked;
						var emailBox = ElementUtil.query(mainToolbar, 'emailToGroupEmail');
						emailBox.disabled = !runPerGroup;
						if (!runPerGroup) {
							emailBox.checked = false;
						}
						var allGroups = ElementUtil.query(mainToolbar, 'allGroups').checked;
						if (allGroups) {
							bulkSplitWrapper.classList.add('hide');
						} else if (ElementUtil.query(mainToolbar, 'selectionType').value === 'BULK_GROUP') {
							bulkSplitWrapper.classList.remove('hide');
						}
					};

					var hideBulkOptions = function() {
						['allGroups', 'runPerGroup', 'emailToGroupEmail', 'globalTags', 'tagHelp', 'groupTags'].forEach(function(itemId) {
							ElementUtil.query(mainToolbar, itemId).classList.add('hide');
						});
					};

					var actionUpdateSelectionType = function (value) {
						hideBulkOptions();
						bulkSplitWrapper.classList.add('hide');
						ElementUtil.query(mainToolbar, 'unitGroup').classList.add('hide');
						splitWrapper.classList.add('hide');

						if (value === 'FLEET') {
							addUnitsWin.height = 200;
							addUnitsWin.width = 450;
							addUnitsWin.adjustContentSize();
						} else if (value === 'GROUP') {
							ElementUtil.query(mainToolbar, 'unitGroup').classList.remove('hide');
							ElementUtil.query(mainToolbar, 'groupTags').classList.remove('hide');
							ElementUtil.query(mainToolbar, 'tagHelp').classList.remove('hide');
							addUnitsWin.height = 260;
							addUnitsWin.width = 700;
							addUnitsWin.adjustContentSize();
						} else if (value === 'BULK_GROUP') {
							var bulkVisible = ['allGroups', 'globalTags', 'tagHelp'];
							if (unitSelection.showReportOptions !== false) {
								bulkVisible.push('runPerGroup', 'emailToGroupEmail');
							} else {
								ElementUtil.query(mainToolbar, 'runPerGroup').checked = false;
								ElementUtil.query(mainToolbar, 'emailToGroupEmail').checked = false;
							}
							bulkVisible.forEach(function(itemId) {
								ElementUtil.query(mainToolbar, itemId).classList.remove('hide');
							});
							actionUpdateBulkOptions();
							addUnitsWin.height = .8;
							addUnitsWin.width = .85;
							addUnitsWin.adjustContentSize();
							if (!ElementUtil.query(mainToolbar, 'allGroups').checked) {
								bulkSplitWrapper.classList.remove('hide');
								actionBulkSelectGrid();
							}
						} else {
							splitWrapper.classList.remove('hide');
							addUnitsWin.height = .75;
							addUnitsWin.width = .75;
							addUnitsWin.adjustContentSize();
						}
					};
					setTimeout(function(){
						actionUpdateSelectionType(unitSelection.value.type);	
						
						if (unitSelection.value.groupId) {
							ElementUtil.query(mainToolbar, 'unitGroup').value = unitSelection.value.groupId;
						}
						if (unitSelection.value.groupTagExpression) {
							ElementUtil.query(mainToolbar, 'groupTags').value = unitSelection.value.groupTagExpression;
						}
						
						allSelectedUnits = (unitSelection.value.customList || []).slice(0);	
						actionUpdatedSelection(allSelectedUnits.slice(0));

						if (unitSelection.value.bulkGroupConfig) {
							var config = unitSelection.value.bulkGroupConfig;
							var reportOptionsEnabled = unitSelection.showReportOptions !== false;
							ElementUtil.query(mainToolbar, 'allGroups').checked = !!config.allGroups;
							ElementUtil.query(mainToolbar, 'runPerGroup').checked = reportOptionsEnabled
									? (config.runPerGroup !== false)
									: false;
							ElementUtil.query(mainToolbar, 'emailToGroupEmail').checked = reportOptionsEnabled
									? !!config.emailToGroupEmail
									: false;
							ElementUtil.query(mainToolbar, 'globalTags').value = config.globalTagExpression || '';
							allSelectedGroups = (config.groups || []).map(function(group) {
								return {
									unitGroupId: group.unitGroupId,
									groupName: group.groupName,
									groupCode: group.groupCode,
									tagExpression: group.tagExpression || ''
								};
							});
							actionBulkUpdatedSelection();
							actionUpdateBulkOptions();
						}
					});										
				}
			}			
		});			

	}

	unitSelectionValue()  {
		var unitSelection = this;
		return unitSelection.value;
	}
	
};
customElements.define('dl-unitselection', UnitSelection);
